<div class="modal-header">
  <h4 class="modal-title">{{ 'bug-report.title' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="bugForm" (ngSubmit)="onSubmit()">
    <!-- Título -->
    <div class="mb-3">
      <label for="title" class="form-label">
        {{ 'bug-report.fields.title' | translate }} <span class="text-danger">*</span>
      </label>
      <input
        type="text"
        id="title"
        class="form-control font-primary"
        formControlName="title"
        [class.is-invalid]="title && title.invalid && title.touched"
        [placeholder]="'bug-report.placeholders.title' | translate"
      />
      <div class="invalid-feedback font-primary" *ngIf="title && title.invalid && title.touched">
        <span *ngIf="title.errors?.['required']">
          {{ 'bug-report.errors.title-required' | translate }}
        </span>
        <span *ngIf="title.errors?.['minlength']">
          {{ 'bug-report.errors.title-min-length' | translate }}
        </span>
        <span *ngIf="title.errors?.['maxlength']">
          {{ 'bug-report.errors.title-max-length' | translate }}
        </span>
      </div>
    </div>

    <!-- Descripción -->
    <div class="mb-3">
      <label for="description" class="form-label">
        {{ 'bug-report.fields.description' | translate }} <span class="text-danger">*</span>
      </label>
      <textarea
        id="description"
        class="form-control"
        formControlName="description"
        rows="5"
        [class.is-invalid]="description && description.invalid && description.touched"
        [placeholder]="'bug-report.placeholders.description' | translate"
      ></textarea>
      <div class="invalid-feedback" *ngIf="description && description.invalid && description.touched">
        <span *ngIf="description.errors?.['required']">
          {{ 'bug-report.errors.description-required' | translate }}
        </span>
        <span *ngIf="description.errors?.['minlength']">
          {{ 'bug-report.errors.description-min-length' | translate }}
        </span>
      </div>
    </div>

    <!-- Prioridad -->
    <div class="mb-3">
      <label for="priority" class="form-label">
        {{ 'bug-report.fields.priority' | translate }} <span class="text-danger">*</span>
      </label>
      <select
        id="priority"
        class="form-select"
        formControlName="priority"
        [class.is-invalid]="priority && priority.invalid && priority.touched"
      >
        <option *ngFor="let p of priorities" [value]="p">
          {{ 'bug-report.priorities.' + p | translate }}
        </option>
      </select>
    </div>

    <!-- Archivos adjuntos -->
    <div class="mb-3">
      <label for="attachments" class="form-label">
        {{ 'bug-report.fields.attachments' | translate }}
        <small class="text-muted">({{ 'bug-report.fields.attachments-optional' | translate }})</small>
      </label>
      <input
        type="file"
        id="attachments"
        class="form-control"
        accept="image/*"
        multiple
        (change)="onFileSelected($event)"
      />
      <small class="form-text text-muted">
        {{ 'bug-report.fields.attachments-hint' | translate }}
      </small>

      <!-- Lista de archivos seleccionados -->
      <div class="selected-files mt-2" *ngIf="selectedFiles.length > 0">
        <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
          <span class="file-name">📎 {{ file.name }}</span>
          <span class="file-size">({{ (file.size / 1024).toFixed(1) }} KB)</span>
          <button type="button" class="btn-remove" (click)="removeFile(i)">×</button>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isSubmitting">
    {{ 'bug-report.buttons.cancel' | translate }}
  </button>
  <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="isSubmitting">
    <span *ngIf="!isSubmitting">{{ 'bug-report.buttons.submit' | translate }}</span>
    <span *ngIf="isSubmitting">
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      {{ 'bug-report.buttons.submitting' | translate }}
    </span>
  </button>
</div>
